export const STORAGE_KEY = {
  DEVICE_ID: '__DEVICE_ID__',
};
